export default {
  good: {
    label: '商品',
    items: [
      { id: 'view_goods', label: '查看商品', checked: true },
      { id: 'add_goods', label: '新增商品' },
      { id: 'modify_goods', label: '修改商品' },
      { id: 'delete_goods', label: '删除商品' },
    ]
  },
  order: {
    label: '订单',
    items: [
      { id: 'view_orders', label: '查看订单' },
      { id: 'modify_orders', label: '修改订单' }
    ]
  }
}
